<script setup>
import { useAttrs } from 'vue';
import goatendiLogoThumbnail from '../../../../../addons/custom-brand-assets/goatendi/logo/logo_thumbnail.svg';

const attrs = useAttrs();
</script>

<template>
  <img v-bind="attrs" :src="goatendiLogoThumbnail" />
</template>
